class RegisterClientRequest {
  constructor(code, name, cnpj, email, phone) {
    this.code = code;
    this.name = name;
    this.cnpj = cnpj;
    this.email = email;
    this.phone = phone;
  }
}

class EditClientRequest {
  constructor(id, code, name, cnpj, email, phone) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.cnpj = cnpj;
    this.email = email;
    this.phone = phone;
  }
}

export { RegisterClientRequest, EditClientRequest };